import {
    Box,
    Grid,
    Typography,
    Link,
    Divider,
    Stack,
} from "@mui/material";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Öffnungszeiten } from '../constants/Öffnungszeiten';

export const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                px: { xs: 3, sm: 8 },
                py: { xs: 6, sm: 8 },
                background: `
                    linear-gradient(
                        180deg,
                        #FAFAFB,
                        #1976d2af
                    )
                    `,
                color: "black",
            }}
        >
            <Grid
                container
                spacing={{ xs: 6, sm: 4 }}
                justifyContent="space-between"
            >
                {/* Contact */}
                <Grid size={{ xs: 12, sm: 4 }}>
                    <Typography variant="h6" fontWeight={600} gutterBottom>
                        Kontakt
                    </Typography>

                    <Stack spacing={1.5}>
                        <Stack direction="row" spacing={1.5} alignItems="flex-start">
                            <LocationOnIcon fontSize="small" color="action" />
                            <Typography variant="body2">
                                Wannerstraße 23–25
                                <br />
                                44649 Herne
                            </Typography>
                        </Stack>

                        <Stack direction="row" spacing={1.5} alignItems="center">
                            <EmailOutlinedIcon fontSize="small" color="action" />
                            <Link
                                href="mailto:info@kanzlei-imrecht.de"
                                underline="hover"
                                color="inherit"
                            >
                                info@kanzlei-imrecht.de
                            </Link>
                        </Stack>

                        <Stack direction="row" spacing={1.5} alignItems="center">
                            <PhoneIcon fontSize="small" color="action" />
                            <Link
                                href="tel:+492325952640"
                                underline="hover"
                                color="inherit"
                            >
                                +49 (0) 2325 952640
                            </Link>
                        </Stack>

                        <Stack direction="row" spacing={1.5} alignItems="center">
                            <PhoneIphoneOutlinedIcon fontSize="small" color="action" />
                            <Link
                                href="tel:+4915202016852"
                                underline="hover"
                                color="inherit"
                            >
                                +49 (0) 152 02016852
                            </Link>
                        </Stack>
                    </Stack>
                </Grid>

                {/* Opening Hours */}
                <Grid size={{ xs: 12, sm: 4 }}>
                    <Typography variant="h6" fontWeight={600} gutterBottom>
                        Öffnungszeiten
                    </Typography>
                    <Öffnungszeiten />
                </Grid>

                {/* Legal */}
                <Grid size={{ xs: 12, sm: 4 }}>
                    <Typography variant="h6" fontWeight={600} gutterBottom>
                        Rechtliches
                    </Typography>

                    <Stack spacing={1}>
                        <Link href="/impressum" underline="hover" color="inherit">
                            Impressum
                        </Link>
                        <Link href="/datenschutz" underline="hover" color="inherit">
                            Datenschutz
                        </Link>
                    </Stack>
                </Grid>
            </Grid>

            <Divider sx={{ my: 6 }} />

            <Typography
                variant="body2"
                color="text.secondary"
                align="center"
            >
                © {new Date().getFullYear()} Kanzlei im Recht. Alle Rechte vorbehalten.
            </Typography>
        </Box>
    );
};

export default Footer;